// extracted by mini-css-extract-plugin
export default {"root":"Myjdo2BbOt","root_xSmall":"XyiSoqsrSn","root_small":"KiL23xuLcx","root_large":"Z_DB4lZVbo","root_xLarge":"ejW0jINH6o","root_xxLarge":"LU7l5UPIv6","root_xxxLarge":"jtEu85YW0i"};